import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { UploadIcon, WriteIcon } from '@/presentation/components/icon/custom-icon';

import { EssayViewModel } from '../../essay.vm';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;

  @media (max-width: 640px) {
    padding: 0;
    align-items: end;
  }
`;

const ModalContent = styled.div`
  position: relative;
  background: #333;
  padding: 32px;
  border-radius: 32px;
  max-width: 859px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100vh;
  max-height: 556px;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
    max-height: unset;
  }
`;

const CloseButton = styled.button`
  font-size: 50px;
  line-height: 1;
  position: absolute;
  padding: 20px;
  right: 0;
  top: 0;
`;

const ModalEssayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  border: 1.5px solid #636769;
  padding: 32px 16px;
  cursor: pointer;
  max-width: 370px;
`;

const ModalTitle = styled.h2`
  font-family: Aprova Nova;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const ModalSubTitle = styled.h3`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: center;
  color: #999999;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ModalEssayButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ModalIconContainer = styled.div`
  background-color: #191a1a80;
  border-radius: 50%;
  margin-bottom: 16px;
  padding: 60px;

  :hover {
    background-color: #00804f;
  }

  svg {
    width: 72px;
    height: 72px;
  }

  @media (max-width: 768px) {
    padding: 30px;

    svg {
      width: 36px;
      height: 36px;
    }
  }
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const EssayTypeModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const vm = useViewModel(EssayViewModel);
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton type="button" onClick={onClose}>
          &times;
        </CloseButton>

        <ModalEssayContent>
          <ModalTitle>Como você quer enviar sua redação?</ModalTitle>
          <ModalEssayButtonsContainer>
            <ButtonContainer
              onClick={() => {
                vm.setIsEssayTypeModalOpen(false);
                navigate('/essays/write');
              }}
            >
              <ModalIconContainer>
                <WriteIcon />
              </ModalIconContainer>
              <ModalTitle>Digitar redação</ModalTitle>
              <ModalSubTitle>Escreva sua redação diretamente na plataforma.</ModalSubTitle>
            </ButtonContainer>
            <ButtonContainer
              onClick={() => {
                vm.setIsEssayTypeModalOpen(false);
                vm.setIsEssayMediaModalOpen(true);
              }}
            >
              <ModalIconContainer>
                <UploadIcon />
              </ModalIconContainer>
              <ModalTitle>Enviar Imagem</ModalTitle>
              <ModalSubTitle>Tire uma foto da sua redação escrita a mão.</ModalSubTitle>
            </ButtonContainer>
          </ModalEssayButtonsContainer>
        </ModalEssayContent>
      </ModalContent>
    </ModalOverlay>
  );
};

export default EssayTypeModal;
